import { render } from "./myreports.vue?vue&type=template&id=4b33f664"
const script = {}

import exportComponent from "F:\\proj-abhinav\\meraki\\patient-portal-v3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__